export default __webpack_public_path__ + "static/media/support-org2.ade3b30b.png";